/** @format */
import { api } from 'utility';
import { getCRKeyUrl, getRDEKeyById, getCrudPublickKeyUrl, getRDTokenUrl, getCRKeyUrlCss } from 'URLs';
class KeysService {
  async addKey(params) {
    return api.put(getCRKeyUrl(), params);
  }

  async editKey(clientId, params) {
    return api.post(getRDEKeyById(clientId), params);
  }

  async getKeyByClientId(clientId) {
    return api.get(getRDEKeyById(clientId)).then((res) => res.data);
  }

  async getList(params) {
    return api.get(getCRKeyUrl(), {
      params,
    });
  }

  async postPublicKey(clientId, params) {
    return api.post(getCrudPublickKeyUrl(clientId), params);
  }

  async getPublicKey(clientId) {
    return api
      .get(getCrudPublickKeyUrl(clientId), { noToastStatuses: [404] })
      .then((res) => res.data);
  }

  async editPublicKey(clientId, data) {
    return api.post(getCrudPublickKeyUrl(clientId), data);
  }

  async deletePublicKey(clientId) {
    return api.delete(getCrudPublickKeyUrl(clientId));
  }

  async getToken() {
    return api.get(getRDTokenUrl());
  }

  async deleteAllToken() {
    return api.delete(getRDTokenUrl());
  }

  async deleteKey(clientId) {
    return api.delete(getRDEKeyById(clientId));
  }
  async getCss(clientId) {
    const url = getCRKeyUrlCss(clientId);
    return api.get(url);
  }
  async CreateCss(clientId, data) {
    const url = getCRKeyUrlCss(clientId);
    return api.post(url, data);
  }
}

export default KeysService;
